import {Grid} from "@mui/material";
import A11ySelect from "../../a11y-select";

const A11ySelectButton = ({viewMode, onNavigate}) => (
  <Grid className="a11y-btn">
    <A11ySelect viewMode={viewMode} onNavigate={onNavigate} />
  </Grid>
);

export default A11ySelectButton;
